import { useTranslation } from 'react-i18next'

import useCopyPreviewMessaging from '../hooks/useCopyPreviewMessaging/useCopyPreviewMessaging'
import * as Styles from './styles'

const EmailPostcodePreview = ({ previewUrl, customCopies, lang, isCustomCopyActive }) => {
  const { t } = useTranslation()
  const { iframeRef } = useCopyPreviewMessaging({ previewUrl, customCopies, lang, isCustomCopyActive })

  if (!previewUrl) return null

  return (
    <Styles.Container>
      <Styles.PreviewIframe
        ref={iframeRef}
        src={previewUrl}
        title={t('Vista previa de email o código postal')}
        sandbox="allow-same-origin allow-scripts"
      />
    </Styles.Container>
  )
}

export default EmailPostcodePreview
